module.exports = __webpack_public_path__ + "img/sunhero_superhero_pic.a8da84d8.png";